import { useCallback } from 'react';

import styles from './style.module.css';

// A row of mutually exclusive filters drawn as chips, each with its count,
// as on the blueprint's Patients board. The pressed one is announced with
// aria-pressed, which is also what the stylesheet highlights.
export function FilterChips({ label, options, value, onChange }) {
  const choose = useCallback(function({ currentTarget }) {
    onChange(currentTarget.value);
  }, [ onChange ]);

  const chips = options.map(function(option) {
    return (
      <button
        key={ option.value }
        className={ styles.chip }
        type='button'
        value={ option.value }
        aria-pressed={ option.value === value }
        onClick={ choose }
      >
        { `${ option.label } · ${ option.count }` }
      </button>
    );
  });

  return <div className={ styles.chips } role='group' aria-label={ label }>{ chips }</div>;
}
